import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { Feedback } from 'src/app/core/models/feedback';
import { FeedbackService } from 'src/app/core/services/feedback.service';
import { MemberInformationService } from 'src/app/core/services/member-information.service';
import { BootstrapFormInputsDirective } from '../../core/directives/bootstrap-form-inputs.directive';
import { BootstrapFormDirective } from '../../core/directives/bootstrap-form.directive';
import { InvalidCharacterRemoverDirective } from '../../core/directives/invalid-character-remover.directive';
import { CharacterCountPipe } from '../../core/pipes/character-count.pipe';

interface RatingConfig {
  rating: number;
  iconClass: string;
}

@Component({
  selector: 'th-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss'],
  imports: [
    BootstrapFormDirective,
    FormsModule,
    InvalidCharacterRemoverDirective,
    BootstrapFormInputsDirective,
    CharacterCountPipe
  ]
})
export class FeedbackComponent implements OnInit, OnDestroy {
  feedback: Feedback = new Feedback();

  memberIdSubscription: Subscription;
  notesMaxLength = 1000;
  submitting = false;

  ratings: RatingConfig[] = [
    { rating: 1, iconClass: 'fas fa-fw fa-frown-open' },
    { rating: 2, iconClass: 'fas fa-fw fa-frown' },
    { rating: 3, iconClass: 'fas fa-fw fa-meh' },
    { rating: 4, iconClass: 'fas fa-fw fa-smile' },
    { rating: 5, iconClass: 'fas fa-fw fa-grin' }
  ];

  constructor(
    private feedbackService: FeedbackService,
    public modalService: NgbModal,
    private router: Router,
    public memberInformationService: MemberInformationService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.memberIdSubscription = this.memberInformationService.memberId.subscribe((memberId) => {
      this.feedback.memberId = memberId;
    });
  }

  ngOnDestroy() {
    this.memberIdSubscription?.unsubscribe();
  }

  selectRating(rating: number) {
    this.feedback.rating = rating;
  }

  submitFeedback() {
    this.submitting = true;

    this.feedback.url = this.router.url;

    this.feedbackService
      .addFeedback(this.feedback)
      .pipe(finalize(() => (this.submitting = false)))
      .subscribe(() => {
        this.toastr.success('Thanks for your feedback!');

        this.modalService.dismissAll();
      });
  }
}
